"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_IGNORED_ADD_TO_BASKET_PLACEMENTS = void 0;
var _analyticsData = require("@ori/analytics-data");
const DEFAULT_IGNORED_ADD_TO_BASKET_PLACEMENTS = exports.DEFAULT_IGNORED_ADD_TO_BASKET_PLACEMENTS = [_analyticsData.Placement.TopNavigationSearchSuggestions];
